<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapState } from "vuex";
import API from "@/api/index";
import Cookies from "js-cookie";
export default {
  computed: {
    ...mapState({
      token: state => state.token,
      openId: state => state.openId
    })
  },
  created() {
    if (this.$route.name === "turn") {
      return true;
    }
    const token = Cookies.get("luck-token");
    if (token) {
      this.$store.commit("setToken", token);
      this.$route.name !== "luck" &&
        this.$router.push({
          name: "luck"
        });
      return true;
    }
    const weChatUrl = `//wx.bom.ai/oauth/SilentAuthorise?returnurl=${location.href}`;
    const openId = this.$route.query.openid;
    if (openId) {
      this.$store.commit("setOpenId", this.$route.query.openid);
    } else {
      window.location.href = weChatUrl;
      return false;
    }
    API.checkRegister(openId).then(res => {
      if (res.Code === 0) {
        this.$router.push({
          name: "register"
        });
      } else {
        this.$router.push({
          name: "turn"
        });
      }
    });
  }
};
</script>

<style lang="scss"></style>
